import { Injectable } from '@angular/core';
import { LoaderService } from '../loader.service';
import { OrgaoSearch } from 'app/services/mob/orgao.search';
import { Orgao } from '@tivic-team/manager-ts/dist/mob';
import { OrgaoController } from 'app/controllers/mob/orgao.controller';
import { LogradouroDTO } from 'app/model/dtos/grl/logradouro.dto';
import { PagedResponse } from 'app/interfaces/paged-response.inteface';
import { LogradouroSearch } from '../grl/logradouro.search';

@Injectable()
export class OrgaoService{

    constructor(
        private _orgaoController:OrgaoController,
        private _loaderService:LoaderService
    ){}

    async find(orgaoSearch?:OrgaoSearch):Promise<Orgao[]>{
        this._loaderService.show();
        return this._orgaoController.find(orgaoSearch && orgaoSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }
    
    async save(orgao:Orgao):Promise<Orgao>{
        this._loaderService.show();
        if(orgao.cdOrgao && orgao.cdOrgao > 0)
            return this._orgaoController.update(orgao).finally(() => this._loaderService.hide());
        else
            return this._orgaoController.create(orgao).finally(() => this._loaderService.hide());
    }

    async get(cdOrgao:number):Promise<Orgao>{
        this._loaderService.show();
        return this._orgaoController.get(cdOrgao).finally(() => this._loaderService.hide());
    }
    
    async findLogradouros(logradouroSearch?:LogradouroSearch):Promise<PagedResponse<LogradouroDTO>>{
        this._loaderService.show();
        return this._orgaoController.findLogradouros(logradouroSearch && logradouroSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }
    
}